import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-684ef83f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("财务费用前：订单金额 - 收款金额")
const _hoisted_2 = { style: {"textAlign":"center"} }
const _hoisted_3 = { class: "numberRectangle" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_5 = { class: "numberRectangle" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "=", -1))
const _hoisted_7 = { class: "numberRectangle" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("填入财务费用")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("填入差异")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("填入坏账")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("财务费用后：订单金额-收款金额-财务费用-差异-坏账")
const _hoisted_14 = { style: {"textAlign":"center"} }
const _hoisted_15 = { class: "numberRectangle" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_17 = { class: "numberRectangle" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_19 = {
  class: "numberRectangle",
  style: {"background":"rgb(201, 220, 255)"}
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_21 = {
  class: "numberRectangle",
  style: {"background":"rgb(201, 220, 255)"}
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_23 = {
  class: "numberRectangle",
  style: {"background":"rgb(201, 220, 255)"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "=", -1))
const _hoisted_25 = { class: "numberRectangle" }

import {ref, reactive, onBeforeMount, computed} from 'vue'
import { formatNumber, getNumber, formatTime } from '@/utils/index'
import { add, number, bignumber } from 'mathjs'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  props: {
    balanceRow: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  balanceRow: any
}

const { 
  // 未匹配订单
  'POST/verification/liquidate/not_match_order': not_match_orderApi,
} = Api


const compareObj: any = reactive({
  // 财务费用
  financialExpenses: 0,
  // 差异
  balance: 0,
  // 坏账
  badDebt: 0,
  // 备注
  notes: '',
})
let compareTable: any = ref([])

const fillCompareObj = (prop: string) => {
  compareObj[prop] = Number(( compareTable.value[0].orderAmount - compareTable.value[0].originalFlow).toFixed(2))
}

// 财务费用前
const beforeFinally = computed(() => {
  return compareTable.value[0].orderAmount - compareTable.value[0].originalFlow
})
// 财务费用后
const afterFinally = computed(() => {
  
  return compareTable.value[0].orderAmount - compareTable.value[0].originalFlow - (compareObj.financialExpenses || 0) - (compareObj.balance || 0) - (compareObj.badDebt || 0)
})

const { 
  MI_tableData, fetchData, page, size, 
  MI_total, MI_pageChange, MI_sizeChange, 
  MI_identify, MI_params, MI_modifyForm, MI_height,
} = new tbMix(not_match_orderApi)

let badDebtOrderRows: any = ref([])
let orderListAmount = computed(() => {
  return badDebtOrderRows.value.reduce((numb: number, row: any) => {
    return numb += Number(row.amount)
  }, 0).toFixed(2)
})

onBeforeMount(() => {

  // compareObj.financialExpenses = props.balanceRow.financialExpenses
  // compareObj.balance = props.balanceRow.balance
  // compareObj.badDebt = props.balanceRow.badDebt
  compareObj.notes = props.balanceRow.notes

  compareTable.value = [{
    custoemrId: props.balanceRow.customerIds[0],
    currency: props.balanceRow.currency,
    // 收款金额为差异
    originalFlow: Math.abs(props.balanceRow.balance),
    handlingFee: props.balanceRow.handlingFee,
    orderAmount: orderListAmount,
  }]
  // 获取未勾销订单
  fetchData({ customerId: props.balanceRow.customerIds[0] })
})

// 提交验证
const submitVerify = () => {
  // 判断财务费用勾销后，是否为0
  if (Math.abs(compareTable.value[0].orderAmount - compareTable.value[0].originalFlow -
      (compareObj.financialExpenses || 0) - (compareObj.balance || 0) - (compareObj.badDebt || 0)
      ).toFixed(2) !== '0.00') {
    ElMessage.warning('财务费用后计算结果不为0')
    return false
  }

  // 坏账不为0，判断订单坏账金额和坏账金额合是否相等
  let badDebtMap: any = { }
  if(compareObj.badDebt > 0){
    // 计算弹框下方相关订单中坏账金额相加数量，
    let sumBadBebt = badDebtOrderRows.value.reduce((numb: number, order: any, index: number) => {
      if(/^\d+(\.\d+)?$/.test(order.badDebt)){
        numb = number(add(bignumber(numb), bignumber(order.badDebt)))
        badDebtMap[order.id] = order.badDebt
      }
      return numb
    }, 0)

    // 各订单坏账金额相加不等于坏账总金额
    if(sumBadBebt !== 0 && sumBadBebt !== Number(compareObj.badDebt)){
      ElMessage.warning('各订单坏账金额相加不等于坏账总额')
      return false
    }
  }

  return {
    // 客户ID
    customerId: props.balanceRow.customerIds[0],
    balance: {
      ...compareTable.value[0],
      financialExpenses: compareObj.financialExpenses || 0,
      balance: compareObj.balance || 0,
      badDebt: compareObj.badDebt || 0,
      notes: compareObj.notes,
      orderAmount: orderListAmount.value,
    },
    orderIds: badDebtOrderRows.value.map((e: any) => e.id),
    badDebtMap,
  }
}


expose({
  submitVerify
})

return (_ctx: any,_cache: any) => {
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, {
      ref: "compareEle",
      model: _unref(compareObj),
      inline: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "财务费用",
          prop: "financialExpenses"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              controls: false,
              modelValue: _unref(compareObj).financialExpenses,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(compareObj).financialExpenses) = $event)),
              placeholder: "请输入财务费用"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "差异",
          prop: "balance"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              controls: false,
              modelValue: _unref(compareObj).balance,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(compareObj).balance) = $event)),
              placeholder: "请输入差异"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "坏账",
          prop: "badDebt"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              controls: false,
              modelValue: _unref(compareObj).badDebt,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(compareObj).badDebt) = $event)),
              placeholder: "请输入坏账"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "备注",
          prop: "notes"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(compareObj).notes,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(compareObj).notes) = $event)),
              placeholder: "请输入备注",
              clearable: "",
              maxlength: "200",
              style: {"width":"350px"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_el_table, {
      border: "",
      data: _unref(compareTable),
      class: "mt-10"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "客户ID",
          prop: "customerId",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "币种",
          prop: "currency"
        }),
        _createVNode(_component_el_table_column, {
          label: "收款金额",
          prop: "originalFlow",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "手续费",
          prop: "handlingFee",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "订单金额",
          prop: "orderAmount",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"])
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_divider, null, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(getNumber)(_unref(compareTable)[0].orderAmount)), 1),
      _hoisted_4,
      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(getNumber)(_unref(compareTable)[0].originalFlow)), 1),
      _hoisted_6,
      _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(getNumber)(_unref(beforeFinally))), 1),
      _hoisted_8,
      _createVNode(_component_el_button, {
        type: "warning",
        class: "mt-10",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (fillCompareObj('financialExpenses')))
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "warning",
        class: "mt-10",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (fillCompareObj('balance')))
      }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "warning",
        class: "mt-10",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (fillCompareObj('badDebt')))
      }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      }),
      _hoisted_12
    ]),
    _createVNode(_component_el_divider, null, {
      default: _withCtx(() => [
        _hoisted_13
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(getNumber)(_unref(compareTable)[0].orderAmount)), 1),
      _hoisted_16,
      _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(getNumber)(_unref(compareTable)[0].originalFlow)), 1),
      _hoisted_18,
      _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(getNumber)(_unref(compareObj).financialExpenses)), 1),
      _hoisted_20,
      _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(getNumber)(_unref(compareObj).balance)), 1),
      _hoisted_22,
      _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(getNumber)(_unref(compareObj).badDebt)), 1),
      _hoisted_24,
      _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(afterFinally).toLocaleString()), 1)
    ]),
    _createVNode(_component_el_collapse, { class: "mt-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, {
          title: '请注意勾选, 勾选订单金额合计：' + _unref(getNumber)(_unref(orderListAmount))
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              ref: "tb",
              border: "",
              data: _unref(MI_tableData),
              onSelectionChange: _cache[7] || (_cache[7] = (rows) => _isRef(badDebtOrderRows) //@ts-ignore
 ? badDebtOrderRows.value = rows : badDebtOrderRows = rows ),
              "max-height": "290px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "selection",
                  width: "55",
                  fixed: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "坏账金额",
                  fixed: "right",
                  width: "110"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_input_number, {
                      controls: false,
                      modelValue: row.badDebt,
                      "onUpdate:modelValue": ($event: any) => ((row.badDebt) = $event),
                      clearable: "",
                      placeholder: "请输入坏账金额"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "订单编号",
                  prop: "no",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "客户名称",
                  prop: "customerUsername",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "发票主体",
                  prop: "invoiceCompany",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "公司名称",
                  prop: "flowCompany",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "订单名称",
                  prop: "name",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "po号",
                  prop: "poNumber",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "币种",
                  prop: "currency",
                  width: "65",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "金额",
                  prop: "amount",
                  align: "right",
                  formatter: _unref(formatNumber),
                  "show-overflow-tooltip": "",
                  width: "125"
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "本位币",
                  prop: "standardMoney",
                  align: "right",
                  formatter: _unref(formatNumber),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "USD金额",
                  prop: "baseCurrencyMoney",
                  align: "right",
                  "show-overflow-tooltip": ""
                }, {
                  default: _withCtx(({row}) => [
                    _createTextVNode(_toDisplayString(_unref(getNumber)(Number(row.baseCurrencyMoney))), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "状态",
                  prop: "status",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "客户经理",
                  prop: "owner",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "开始时间",
                  prop: "startTime",
                  formatter: _unref(formatTime),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "完工时间",
                  prop: "deliverTime",
                  formatter: _unref(formatTime),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "确认完工时间",
                  prop: "confirmDeliverTime",
                  formatter: _unref(formatTime),
                  width: "120",
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "关单时间",
                  prop: "closeTime",
                  formatter: _unref(formatTime),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "确认关单时间",
                  prop: "confirmCloseTime",
                  formatter: _unref(formatTime),
                  width: "120",
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "核销时间",
                  prop: "verifyTime",
                  formatter: _unref(formatTime),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"])
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, _unref(MI_identify)]
            ]),
            _createVNode(_component_el_pagination, {
              total: _unref(MI_total),
              "page-size": _unref(size),
              small: "",
              currentPage: _unref(page),
              "onUpdate:currentPage": _cache[8] || (_cache[8] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
              class: "mt-10",
              "page-sizes": [10, 30, 50, 100],
              layout: "sizes, prev, pager, next, total, jumper",
              onCurrentChange: _unref(MI_pageChange),
              onSizeChange: _unref(MI_sizeChange)
            }, null, 8, ["total", "page-size", "currentPage", "onCurrentChange", "onSizeChange"])
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _: 1
    })
  ]))
}
}

})